import { Subject } from 'rxjs';

class NotificationService {
    constructor() {
        this.unreadNotifications = new Subject();
        this.totalNotifications = new Subject();
    }
    
    setUnread(num) {
        this.unreadNotifications.next(num);
    }

    setTotalNotifications(num) {
        this.totalNotifications.next(num);
    }
}

export default new NotificationService();


// WEBPACK FOOTER //
// ./src/services/NotificationService/NotificationService.js